module.exports = __webpack_public_path__ + "img/two-dimensional_2.fed4af2c.png";